export function monthLabelShort(value: string): string {
  const date = new Date(`${value}-01T12:00:00`);
  return date.toLocaleDateString("en-GB", { month: "short", year: "numeric" });
}

export function monthLabelLong(value: string): string {
  const date = new Date(`${value}-01T12:00:00`);
  return date.toLocaleDateString("en-GB", { month: "long", year: "numeric" });
}

export function monthLabelChart(value: string): string {
  const date = new Date(`${value}-01T12:00:00`);
  return date.toLocaleDateString("en-GB", { month: "short" });
}
